<template>
  <NdsModal
    :close-on-backdrop="false"
    :close-on-esc="false"
    :show-close-button="state?.showCloseButton ?? false"
    :size="NdsModalSize.SMALL"
    :value="state !== null"
    @close="handleCancel"
  >
    <template
      v-if="state?.title"
      #title
    >
      {{ state.title }}
    </template>

    <template #content>
      <div class="ndsConfirmDialog__content">
        <NdsText :size="NdsTextSizes.L">
          {{ state?.message }}
        </NdsText>
      </div>
    </template>

    <template #footer>
      <NdsButton
        v-if="state?.cancelLabel !== null"
        :color="NdsButtonColor.SECONDARY"
        data-testid="nds-confirm-cancel"
        @click="handleCancel"
      >
        {{ state?.cancelLabel }}
      </NdsButton>

      <NdsButton
        :color="state?.okColor ?? NdsButtonColor.PRIMARY"
        data-testid="nds-confirm-ok"
        @click="handleOk"
      >
        {{ state?.okLabel }}
      </NdsButton>
    </template>
  </NdsModal>
</template>

<script setup lang="ts">
import NdsModal from '@/components/NewDesignSystem/NdsModal/NdsModal.vue'
import NdsButton from '@/components/NewDesignSystem/NdsButton/NdsButton.vue'
import NdsText from '@/components/NewDesignSystem/NdsText/NdsText.vue'
import { NdsModalSize } from '@/components/NewDesignSystem/NdsModal/NdsModal.interfaces'
import { NdsButtonColor } from '@/components/NewDesignSystem/NdsButton/NdsButton.interfaces'
import { NdsTextSizes } from '@/components/NewDesignSystem/NdsText/NdsText.interfaces'
import { useConfirmDialog } from '@/components/NewDesignSystem/NdsConfirmDialog/UseConfirmDialog.composables'

const { dialogState: state } = useConfirmDialog()

const handleOk = () => {
  state.value?.resolve()
  state.value = null
}

const handleCancel = () => {
  state.value?.reject()
  state.value = null
}
</script>

<style lang="postcss" scoped>
.ndsConfirmDialog {
  &__content {
    padding: var(--spacing-2);
  }
}
</style>
